<template>
  <div id="bjzc-team">
    <PageHeading>律师团队</PageHeading>
    <div uk-grid class="uk-child-width-1-1 uk-child-width-1-3@m">
      <div v-for="lawyer in lawyerList" :key="lawyer.id">
        <TeamListItem :lawyer="lawyer" />
      </div>
    </div>
  </div>
</template>

<script>
import TeamListItem from '../components/TeamListItem.vue'
export default {
  name: '',
  components: { TeamListItem },
  data() {
    return {
      lawyerList: [
        {
          name: '姓名',
          title: '律师',
          content: '律师介绍'
        }
      ]
    }
  },
  created() {
    this.getList()
    this.$eventBus.$emit('setBreadcrumb', [
      { path: '/', title: '首页', title_en: 'Home' },
      {
        path: '/team',
        title: this.$t('breadcrumb.team', 'zh'),
        title_en: this.$t('breadcrumb.team', 'en')
      }
    ])
  },
  methods: {
    getList() {
      this.$axios.get('lawyers').then(res => {
        this.lawyerList = res.data
      })
    }
  }
}
</script>

<style lang="scss"></style>
